import axios from 'axios';
import { useQuery } from '@tanstack/react-query';

import { ResponseEmployee } from 'models/config/Employee';

export function useEmployees() {
    return useQuery({
        queryKey: ['employees'],
        queryFn: ({ signal }) =>
            axios.get<ResponseEmployee>('/v1/user', {
                signal,
                headers: {
                    Authorization: `Bearer ${localStorage.getItem(
                        'LG_APPLICATION'
                    )}`,
                },
            }),
        select: (response) => response.data.result_list,
        refetchOnWindowFocus: false,
    });
}
